export default "__VITE_ASSET__KHbUCCc$__"